import { format, parseISO } from "date-fns";
import {
  classifyErrorBadge,
  ERROR_TYPE_LABELS,
} from "@/features/acquireBookStatus/utils/errorClassifier";
import { type AcquiredDocument } from "../types";

export const OPTION_LABELS: Record<string, string> = {
  KYODOTANPOMOKUROKU: "共同担保目録",
  KYODOTANPOMOKUROKU_GENZAI: "共同担保目録（現在事項のみ）",
  SHINTAKUMOKUROKU: "信託目録",
  SHINTAKUMOKUROKU_GENZAI: "信託目録（現在事項のみ）",
  HEISATOUKIBO: "閉鎖登記簿",
};

/** 閉鎖年月日は日本の登記の日付として、閲覧環境のタイムゾーンに依存させない */
export const formatClosedDate = (value: string): string =>
  new Intl.DateTimeFormat("ja-JP", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(parseISO(value));

/** 既存の依頼詳細と同じ状態・失敗理由を出力する */
export const formatDocumentStatusForExport = (
  document: AcquiredDocument
): string => {
  if (document.status === "SUCCEEDED") return document.uri ? "取得済み" : "";
  if (document.status === null) return "取得中";

  const badge = classifyErrorBadge(document.errorDetail, document.errorCode);
  const label = badge ? ERROR_TYPE_LABELS[badge.type] : null;
  return (
    [label, document.errorDetail?.trim()].filter(Boolean).join(": ") ||
    ERROR_TYPE_LABELS.GENERIC_FAILED
  );
};

/** 原本入手日を日付のみで出力する */
export const formatDocumentDateForExport = (
  document: AcquiredDocument
): string =>
  document.acquiredDate
    ? format(parseISO(document.acquiredDate), "yyyy/MM/dd")
    : "";
